<template>
  <b-sidebar
    id="add-new-stage-sidebar"
    :visible="isAddNewProjectStageSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="
      (val) => $emit('update:is-add-new-project-stage-sidebar-active', val)
    "
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        "
      >
        <h5 class="mb-0">{{ button_text }}項目狀態</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <!-- 項目狀態-->
            <validation-provider
              #default="validationContext"
              name="項目狀態"
              rules="required"
            >
              <b-form-group label="項目狀態" label-for="stage">
                <b-form-input
                  id="stage"
                  v-model="projectstageData.stage"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="項目狀態"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- 描述 -->
            <validation-provider
              #default="validationContext"
              name="描述"
              rules="required"
            >
              <b-form-group label="描述" label-for="description">
                <b-form-textarea
                  id="description"
                  v-model="projectstageData.description"
                  placeholder="描述"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  style="display: none"
                />
                <quill-editor v-model="projectstageData.description" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Background Color-->
            <validation-provider
              #default="validationContext"
              name="Background Color"
              rules="required"
            >
              <b-form-group label="Background Color" label-for="background_color">
                <b-input-group>
                <b-form-input
                  id="background_color"
                  v-model="projectstageData.background_color"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Background Color"
                />
                <b-input-group-append is-text>
                <el-color-picker v-model="projectstageData.background_color" size="mini"></el-color-picker>
                </b-input-group-append>
                </b-input-group>
                
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

             <!-- Font Color-->
            <validation-provider
              #default="validationContext"
              name="Font Color"
              rules="required"
            >
              <b-form-group label="Font Color" label-for="font_color">
                <b-input-group>
                <b-form-input
                  id="font_color"
                  v-model="projectstageData.font_color"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Font Color"
                />
                <b-input-group-append is-text>
                <el-color-picker v-model="projectstageData.font_color" size="mini"></el-color-picker>
                </b-input-group-append>
                </b-input-group>
                
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :style="{ color: projectstageData.font_color+' !important', background: projectstageData.background_color+' !important'}"
            class="demo_button"
            >
            {{ (projectstageData.stage)?projectstageData.stage:'Demo' }}


            </b-button>

            <!-- Form Actions -->

            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ button_text }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </validation-observer>
    </template></b-sidebar
  >
</template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BFormCheckbox,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    vSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewProjectStageSidebarActive",
    event: "update:is-add-new-project-stage-sidebar-active",
  },
  props: {
    isAddNewProjectStageSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      max,
    };
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const blankProjectStageData = {
      id: 0,
      stage: "",
      description: "",
      background_color: "#A5853D",
      font_color: "#FFFFFF",
    };
    const button_text = ref("新增");

    const projectstageData = ref(
      JSON.parse(JSON.stringify(blankProjectStageData))
    );

    const resetprojectstageData = () => {
      projectstageData.value = JSON.parse(
        JSON.stringify(blankProjectStageData)
      );
    };

    const toast = useToast();

    watch(
      () => [props.id, props.isAddNewProjectStageSidebarActive],
      () => {
        if (props.id > 0 && props.isAddNewProjectStageSidebarActive) {
          projectstageData.value.id = props.data.id;
          projectstageData.value.stage = props.data.stage;
          projectstageData.value.description = props.data.description;
          projectstageData.value.background_color = props.data.background_color;
          projectstageData.value.font_color = props.data.font_color;
          
          if (projectstageData.value.id > 0) {
            button_text.value = "修改";
          } else {
            button_text.value = "新增";
          }
        } else {
          button_text.value = "新增";
        }
      }
    );

    const onSubmit = () => {
      loading.value = true;
      store
        .dispatch(
          "setting-projectstage/addProjectStage",
          projectstageData.value
        )
        .then((response) => {
          loading.value = false;
          emit("update:is-add-new-project-stage-sidebar-active", false);
          emit("refetch-data");
          toast({
            component: ToastificationContent,
            props: {
              title: "Success",
              text: response.data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          loading.value = false;
          toast({
            component: ToastificationContent,
            props: {
              title: "Fail",
              text: error.response.data.message,
              icon: "HeartIcon",
              variant: "danger",
            },
          });
        });
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetprojectstageData
    );

    return {
      projectstageData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      button_text,
      loading,
    };
  },
};
</script>

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
#add-new-stage-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.ql-editor {
  height: 300px;
}

.input-group-text{
  padding:0 1rem;
}
.demo_button{
  width:100%;
  min-height:35px;
}
</style>